/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="performanceInsights.module.ts" />
/// <reference path="performanceInsights.context.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
/// <reference path="../../components/common/security.keys.ts" />
/// <reference path="../../components/common/security.parts.ts" />

module Meevo.Plugins.PerformanceInsights {

    import PageStateEnum = Meevo.Model.PageStateEnum;
    import IReportsHelper = Meevo.Plugins.Reports.IReportsHelper;

    class PerformanceInsightsController {
        static $inject = [
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            '$rootScope',
            '$scope',
            '$state',
            'meevo.ContextParams',
            'meevo.components.busy.BusyService',
            '$q',
            '$http',
            'meevo.plugins.reports.ReportsHelper',
            '$translate',
        ];

        context: IPerformanceInsightsContext;

        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        protected securityParts = Meevo.Components.Common.SecurityParts;

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $q: angular.IQService,
            protected $http: angular.IHttpService,
            protected reportsHelper: IReportsHelper,
            protected $translate: angular.translate.ITranslateService) {
            this.context = new PerformanceInsightsContext(
                appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                busyService,
                securityService,
                $scope,
                $q,
                $http,
                reportsHelper,
                $translate
            );

            this.securityService
                .checkSection(this.securityKeys.INSIGHTS)
                .finally(() => {
                    if (!contextParams.params) {
                        this.context.activate();
                    }
                });

            this.setConvoContext(contextParams.params);
            this.loadContextData(contextParams.params);
            this.$scope.$on(Meevo.Components.Common.Messages.APPLY_PARAMS_TO_CONTEXT, (evt, state, params: { convoInput: string; report?: string; }) => {
                if (state.name !== this.appSettings.ROUTE_NAMES.performanceInsights) {
                    return;
                }

                if (this.context) {
                    this.context.searchFilter = '';
                }

                this.setConvoContext(params);
                this.loadContextData(params);
            });

            this.$scope.$watch(() => this.identityService.current().sessionId, (newValue: string, oldValue: string) => {
                if (newValue === oldValue || this.context.showMenuType !== PageStateEnum.Report) {
                    return;
                }

                this.context.goBack();
            });
        }

        protected setConvoContext(params): any {
            if (!params) {
                return;
            }
            if (params.report) {
                params.reportContext = {
                    id: params.reportId,
                    reportCatId: params.reportCatId
                };
                params.action = 'GOTO_REPORT';
                return;
            }
            if (params.categoryId) {
                params.reportContext = {
                    reportCatId: params.categoryId
                };
                params.action = 'GOTO_REPORT_CATEGORY';
                return;
            }
        }

        protected loadContextData(params) {
            if (!params || !params.action) {
                this.context.activate();
                return;
            }

            if (params.action === 'GOTO_REPORT') {
                this.context.loadReportFromParams(params);
            }
            if (params.action === 'GOTO_REPORT_CATEGORY') {
                this.context.loadReportCategoryFromParams(params);
            }
        }

        /**
         * Close plugin
         */
        closeContext = (): void => {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
        }
    }

    angular.module('meevo.plugins.performanceInsights')
        .controller('meevo.plugins.performanceInsights.PerformanceInsightsController', PerformanceInsightsController);
}
